export const discount_routes = [
  {
    path: "/discounts",
    component: () => import("../Main.vue"),
    name: "Descontos"
  }
];

export default {};
